export default {
  path: 'page/live/:classId/:courseId',
  props: true,
  component: resolve => require(['../../../pages/teacher/classin/page'], resolve)
}



// WEBPACK FOOTER //
// ./src/router/teacher/classin/pageLive.js